export const DEFAULT_TYPE = "info";
export const DEFAULT_VARIANT = "subtle";

export const defaultVariants = {
    type: DEFAULT_TYPE,
    variant: DEFAULT_VARIANT
} as const;
